import {Controller} from "stimulus"
import Inputmask from "inputmask";

export default class extends Controller {
    static targets = [
        "input"
    ]

    static values = {
        mask: String,
        sourceSelector: String,
        maskField: String,
        url: String
    }

    connect() {
        this.applyMask();
    }

    fetchMask() {
        if (this.hasSourceSelectorValue && this.hasMaskFieldValue && this.hasUrlValue) {
            let id = document.getElementById(this.sourceSelectorValue).value;
            let url = this.urlValue.replace("-1", id);
            let maskField = this.maskFieldValue;
            fetch(url)
                .then((response) => {
                    return response.json()
                })
                .then((data) => {
                    this.maskValue = data[maskField];
                    this.applyMask();
                });
        }
    }

    applyMask() {
        if (this.maskValue && this.maskValue !== 'null') {
            let inputMask = new Inputmask(this.maskValue);
            inputMask.mask(this.inputTarget);
        } else {
            this.maskValue = "*{*}"
            let inputMask = new Inputmask(this.maskValue);
            inputMask.mask(this.inputTarget);
        }
    }


}